var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"d-inline-block",attrs:{"to":"/"}},[_c('div',{staticClass:"logo pr-4"},[_c('img',{attrs:{"src":_vm.letters === 'white' ? '/img/logo_white.svg' : '/img/logo_black.svg',"height":_vm.height}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }